/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/
import { lazy } from "react";

export default {
	'test-message-inapp': lazy(
			() =>
			import(
				/* webpackChunkName: "[request]" */
				'@post-office/message-template--test-message-inapp/placements/in-app/app-switcher-discovery-section/render'
			),
	),
	'test-message-inapp-engagement': lazy(
			() =>
			import(
				/* webpackChunkName: "[request]" */
				'@post-office/message-template--test-message-inapp-engagement/placements/in-app/app-switcher-discovery-section/render'
			),
	),
	'test-message-marketing': lazy(
			() =>
			import(
				/* webpackChunkName: "[request]" */
				'@post-office/message-template--test-message-marketing/placements/in-app/app-switcher-discovery-section/render'
			),
	),
};
